import { render, staticRenderFns } from "./getView.vue?vue&type=template&id=6406a383&scoped=true&"
import script from "./getView.vue?vue&type=script&lang=js&"
export * from "./getView.vue?vue&type=script&lang=js&"
import style0 from "./getView.vue?vue&type=style&index=0&id=6406a383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406a383",
  null
  
)

export default component.exports